import Cookies from "js-cookie";
import authenticate from '~/backend/authenticate';
import fetchCurrentUserConfigs from '~/backend/fetchCurrentUserConfigs';
import createSuccessPromiseThunk from "~/rx/lib/createSuccessPromiseThunk";
import {initializeCurrentLocation} from "redux-little-router";
import {modify} from "mythil/object";
import {getCredentials} from "~/stateGetter";
import get from 'lodash/get';
import omit from 'lodash/omit';
import mapValues from "lodash/mapValues";
import { setConfig } from "../config";


const actions = {
    setValue: (value, customParams = {}) => {
        return (dispatch, getState) => {
            dispatch({ type: 'authenticate_successfull', value: value, ...customParams });

            const initialLocation = getState().router;
            dispatch(initializeCurrentLocation(initialLocation));
        };
    }
};

let { reduce, execute, types, initialState,  } = createSuccessPromiseThunk({
    name: 'authenticate',
    actions,
    func: async ({dispatch, getState, getConfig, username, password, token}) => {
        let authResult = null;

        if(username && username.length && password && password.length) {
            authResult = (await authenticate(getConfig().baseUrl, username, password));
        } else if(token && token.length) {
            authResult = (await fetchCurrentUserConfigs(getConfig().baseUrl)) || {};
        } else {
            // TODO: add language var for this (we will refactor translation anyway so i was lazy)
            dispatch({ type: 'authenticate_errored', error: 'Bitte geben Sie Ihre Anmeldedaten sachgemäss ein.' });
            return;
        }

        if(authResult.success) {
            const uniqueId = authResult.unique_id+'-'+authResult.user.user_id,
                companyTitle = authResult.company_title,
                locationName = authResult.location_name;

            Cookies.set('token', authResult.user.token);
            window.Intercom?.('update', {
                app_id: 'gc6qyg0y',
                email: authResult.user.email,
                created_at: authResult.created_at,
                name: authResult.user.name,
                user_id:  uniqueId,
                phone: authResult.phone,
                company: companyTitle,
                website: window.location.href
            });

            window.Upscope?.('updateConnection', {
                uniqueId,
                identities: [authResult.name, companyTitle, locationName, authResult.username, window.location.href]
            });
        } else {
            Cookies.set('token', '');
            dispatch({ type: 'authenticate_errored', error: authResult.friendly_error });
            // throw new Error(authResult.friendly_error);
        }

        return authResult;
    },
    successHandler: ({dispatch, value, setValue, setErrored, customParams}) => {
        if(get(value, "unique_id")) {
            dispatch(setValue(value, customParams));
        }

        return true;
    }
});

let originalExecute = execute;
execute = (parameters = {}) => (dispatch, getState) => {
    let stateCredentials = getCredentials(getState());
    if(!parameters.username || !parameters.username.length) { parameters.username = stateCredentials.username }
    if(!parameters.token || !parameters.token.length) { parameters.token = stateCredentials.token }

    return originalExecute(parameters, parameters)(dispatch, getState);
};

// TODO: adjust to new loading state
let originalReduce = reduce;
reduce = (state, action) => {
    switch(action.type) {
        case types.SUCCESS:
            return {
                ...state,
                ...initialState,
                finished_at: Date.now(),
                value: true,
                error: null,
            };
        case types.ERROR:
            return {
                ...state,
                ...initialState,
                value: false,
                error: action.error,
            };
        default:
            return originalReduce(state, action);
    }
};

const reduceAuthState = (state, action) => {
      switch(action.type) {
          case types.SUCCESS:
                state = modify(state, 'credentials', {username: action.value.username});
                state = modify(state, 'availableModels', action.value.configNames);

                const settings = action.value.user.settings ? mapValues(action.value.user.settings, (model) => Array.isArray(model) ? {} : model) : {}
                state = modify(state, 'ui.settings', settings);
                state = modify(state, 'ui.sharedViews', action.value.sharedViews);
                state = modify(state, 'menu', action.value.menu);
                setConfig({ ...omit(action.value, "token", "settings"), user: action.value.user })
              break;
      }

      return state;
};

export { types as AUTH_TYPES, reduce as reduceAuth, execute as authenticate, reduceAuthState };